import React from 'react'
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Language, Location, Home, Masajid, Masjid, Sample, Login, Register, EventForm, MasjidForm, MasjidList, MasjidTimings } from '../pages';

function AppRoutes() {
    return (
        <Router>
            <Switch>
                {/* <Route path='/namaz-time/:id' render={props => <NamazTime {...props}  />} /> */}
                <Route path='/masjid-timings/:id' render={props => <MasjidTimings {...props}  />} />
                <Route path='/event-form/:id' render={props => <EventForm {...props}  />} />
                <Route path='/masjid-form/:id' render={props => <MasjidForm {...props}  />} />
                <Route path='/masjid-list' render={props => <MasjidList {...props}  />} />
                <Route path='/login' render={props => <Login {...props}  />} />
                <Route path='/register' render={props => <Register {...props}  />} />
                <Route path='/masjid/:id' render={props => <Masjid {...props}  />} />
                <Route path='/masajid' render={props => <Masajid {...props}  />} />
                <Route path='/home' render={props => <Home {...props}  />} />
                <Route path='/location' render={props => <Location {...props}  />} />
                <Route path='/' render={props => <Language {...props}  />} />
            </Switch>
        </Router>
    )
}

export default AppRoutes;